import React, { isValidElement, type ReactElement, type ReactNode } from 'react';

type CaseProps<T = unknown> = {
    when: T | undefined | null | false;
    children: ReactNode | ((item: T) => ReactNode);
};

// This is just a marker component, rendering is handled by Match
// oxlint-disable-next-line no-unused-vars
export function Case<T>(_: CaseProps<T>): ReactElement | null {
    return null;
}

export function Match({
    fallback = null,
    children,
}: {
    fallback?: ReactNode;
    children: ReactNode;
}) {
    let match: ReactNode = null;

    React.Children.forEach(children, (child) => {
        if (match != null) {
            return;
        }

        if (isValidElement(child) && child.type === Case) {
            const { when, children: matchChildren } = child.props as CaseProps;

            if (when) {
                match = typeof matchChildren === 'function' ? matchChildren(when) : matchChildren;
            }
        }
    });

    return <>{match ?? fallback}</>;
}
